<script lang="ts">
  // Based on script from mrdoob/stats.js
  // https://github.com/mrdoob/stats.js

  import { onMount } from 'svelte';

  // #region props
  export let name = 'Stats';
  export let fg = '#0ff';
  export let bg = '#002';
  export let updateDelay = 1000;
  export let bottomMessage = '';
  // #endregion

  // #region setup
  let min = Number.POSITIVE_INFINITY;
  let max = 0;
  let lastUpdate = 0;

  let PR = 1;
  let WIDTH = 80;
  let HEIGHT = 48;
  let HEIGHT_W_BOT = 60;
  let TEXT_X = 3;
  let TEXT_Y = 2;
  let TEXT_Y_BOT = 48;
  let GRAPH_X = 3;
  let GRAPH_Y = 15;
  let GRAPH_WIDTH = 74;
  let GRAPH_HEIGHT = 30;

  let canvas: HTMLCanvasElement;
  let ctx: CanvasRenderingContext2D;
  // #endregion

  // #region update
  const init = () => {
    // update with PR once window is loaded
    PR = Math.round(window.devicePixelRatio || 1);
    WIDTH *= PR;
    HEIGHT *= PR;
    HEIGHT_W_BOT *= PR;
    TEXT_X *= PR;
    TEXT_Y *= PR;
    TEXT_Y_BOT *= PR;
    GRAPH_X *= PR;
    GRAPH_Y *= PR;
    GRAPH_WIDTH *= PR;
    GRAPH_HEIGHT *= PR;

    canvas.width = WIDTH;
    canvas.height = bottomMessage.length > 0 ? HEIGHT_W_BOT : HEIGHT;

    ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
    ctx.font = `bold ${9 * PR}px Helvetica,Arial,sans-serif`;
    ctx.textBaseline = 'top';

    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, WIDTH, bottomMessage.length > 0 ? HEIGHT_W_BOT : HEIGHT);

    ctx.fillStyle = fg;
    ctx.fillText(name, TEXT_X, TEXT_Y);
    if (bottomMessage.length > 0) {
      ctx.fillText(bottomMessage, TEXT_X, TEXT_Y_BOT);
    }
    ctx.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);

    ctx.fillStyle = bg;
    ctx.globalAlpha = 0.9;
    ctx.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);

    lastUpdate = (performance || Date).now();
  };

  export const update = (value: number, maxValue: number, updatedBottomMessage?: string) => {
    if (!ctx) {
      return;
    }
    if ((performance || Date).now() - lastUpdate < updateDelay) {
      return;
    }

    min = Math.min(min, value);
    max = Math.max(max, value);

    ctx.fillStyle = bg;
    ctx.globalAlpha = 1;
    ctx.fillRect(0, 0, WIDTH, GRAPH_Y);
    ctx.fillStyle = fg;
    ctx.fillText(`${Math.round(value)} ${name} (${Math.round(min)}-${Math.round(max)})`, TEXT_X, TEXT_Y);
    if (bottomMessage && updatedBottomMessage?.length) {
      ctx.fillStyle = bg;
      ctx.fillRect(0, GRAPH_Y + GRAPH_HEIGHT, WIDTH, HEIGHT_W_BOT - GRAPH_HEIGHT);
      ctx.fillStyle = fg;
      ctx.fillText(updatedBottomMessage, TEXT_X, TEXT_Y_BOT);
    }

    ctx.drawImage(
      canvas,
      GRAPH_X + PR,
      GRAPH_Y,
      GRAPH_WIDTH - PR,
      GRAPH_HEIGHT,
      GRAPH_X,
      GRAPH_Y,
      GRAPH_WIDTH - PR,
      GRAPH_HEIGHT
    );

    ctx.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT);

    ctx.fillStyle = bg;
    ctx.globalAlpha = 0.9;
    ctx.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, Math.round((1 - value / (maxValue * 1.1)) * GRAPH_HEIGHT));

    lastUpdate = (performance || Date).now();
  };
  // #endregion

  // #region lifecycle
  onMount(() => {
    init();
  });
  // #endregion
</script>

<canvas bind:this={canvas} />
